/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Autocomplete, Box, TextField } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import UserService from "../../services/userService";

const cacheRtl = createCache({ key: 'muirtl', stylisPlugins: [rtlPlugin] });
const cacheLtr = createCache({ key: 'ltr' });

const SupervisorDropdown = ({ helperText, error, setFormValues, isFilter, selectedSupervisor, setSelectedSupervisor }) => {
    const theme = useTheme();
    const { t, i18n } = useTranslation();

    const [supervisors, setSupervisors] = useState([]);


    useEffect(() => {
        const fetchSupervisors = async () => {
            try {
                const data = await UserService.fetchAllSupervisors();
                setSupervisors(data);
            } catch (error) {
                console.error('Error fetching pages:', error);
            }
        };
        fetchSupervisors();
    }, []);

    return (
        <CacheProvider value={i18n.language === 'en' ? cacheLtr : cacheRtl}>
            <Autocomplete
                options={supervisors}
                getOptionLabel={(option) => option.name || ""}
                value={selectedSupervisor}
                onChange={(event, newValue) => {
                    setSelectedSupervisor(newValue);
                    setFormValues && setFormValues((prevValues) => ({
                        ...prevValues,
                        supervisorId: newValue ? newValue.id : null,
                    }));
                }
                }
                renderOption={(props, option) => (
                    <li {...props} key={option.id}>
                        {option.name}
                    </li>
                )}
                renderInput={(params) => (
                    <Box>
                        {
                            !isFilter && <p
                                style={{
                                    color: theme.palette.text.primary,
                                    fontSize: 13,
                                    marginTop: 24,
                                    marginBottom: 4,
                                }}
                            >
                                {t("supervisor")}
                            </p>
                        }

                        <TextField
                            {...params}
                            variant={isFilter ? 'standard' : 'outlined'}
                            fullWidth
                            placeholder={isFilter ? t('supervisor') : t('chooseSupervisor')}
                            error={!!error}
                            helperText={helperText}
                            InputProps={{
                                ...params.InputProps,
                                ...(isFilter ? { disableUnderline: true } : {}),
                                endAdornment: (
                                    <>
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                                style: {
                                    backgroundColor: isFilter ? 'transparent' : theme.palette.customGrey.insideInput,
                                    padding: '6px 8px',
                                },
                            }}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: theme.palette.customGrey.borderInput,
                                    },
                                    '&:hover fieldset': {
                                        borderColor: theme.palette.customGrey.borderInput,
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: theme.palette.primary.main,
                                    },
                                },
                                '& .MuiInputBase-input': {
                                    color: theme.palette.text.primary,
                                    padding: '6px 8px',
                                    '&::placeholder': {
                                        fontSize: '14px',
                                        color: theme.palette.text.secondary,
                                        opacity: 1,
                                    },
                                },
                            }}
                        />
                    </Box>
                )}
            />
        </CacheProvider>
    );
}

export default SupervisorDropdown;